
import React, { Component } from 'react';
import { Modal, Button, Descriptions } from 'antd';

const fields = [{
    "text": "业务单号",
    "field": "applicationId",
}, {
    "text": "客户来源",
    "field": "customerSource",
}, {
    "text": "客户名称",
    "field": "customerName",
}, {
    "text": "扣款类型",
    "field": "type",
}, {
    "text": "车架号",
    "field": "vin",
}, {
    "text": "车牌号",
    "field": "plateNo",
}, {
    "text": "金额",
    "field": "commission",
}, {
    "text": "是否折扣",
    "field": "hasDiscount",
}, {
    "text": "实际费用",
    "field": "actualComission",
}, {
    "text": "收款时间",
    "field": "collectionTime",
}, {
    "text": "新车牌号",
    "field": "newPlateNo",
}, {
    "text": "创建人",
    "field": "operator",
}, {
    "text": "创建时间",
    "field": "insertTime",
}, {
    "text": "接单人",
    "field": "grabUser",
}, {
    "text": "接单时间",
    "field": "grabTime",
}, {
    "text": "备注",
    "field": "remark",
}];



class AgentApplyRecord extends Component {
    render() {
        const { visible, onCancel, editData } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="详细信息"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                footer={[
                    <Button key="take" type="primary" onClick={onCancel}>确定</Button>,
                ]}
            >
                <Descriptions title="" bordered column={2}>
                    {fields.map((item, index) => {
                        let val = editData[item.field]
                        return <Descriptions.Item key={index} label={item.text}>{val}</Descriptions.Item>
                    })}
                </Descriptions>
            </Modal>
        );
    }
}


export default AgentApplyRecord;